import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { Grid, Typography, Stack } from '@gogame/components';
import { FormField } from '@gogame/form';
import { dateFNS } from '@gogame/intl-ts';

import { ON_DATE, START_TIME, TIME_LIST, DAYS_LIST, DAYS } from './constants';

export const OnDateFiled = () => (
  <Grid container spacing={1} alignItems={'center'}>
    <Grid item>
      <Typography>on</Typography>
    </Grid>
    <Grid item>
      <FormField.DatePicker
        name={ON_DATE}
        minDate={dateFNS.startOfDay(new Date())}
        _cleanOnUnmount={true}
        timeZone={'local'}
        padding={'0'}
      />
    </Grid>
  </Grid>
);

export const StartTimeField = () => (
  <Stack spacing={1} alignItems={'center'} direction={'row'}>
    <Typography>at</Typography>
    <FormField.TimeInput
      placeholder={'00:00'}
      name={START_TIME}
      options={TIME_LIST}
      lazy={true}
      _cleanOnUnmount={true}
      padding={'0'}
    />
  </Stack>
);

const valdateField = (value) => {
  return !value ||
    value === undefined ||
    (Array.isArray(value) && isEmpty(value))
    ? `Run day is required`
    : undefined;
};

export const DaysField = () => (
  <Grid container spacing={1} alignItems={'flex-start'}>
    <Grid item>
      <Typography style={{ paddingTop: '8px' }}>Run&nbsp;days:</Typography>
    </Grid>
    <Grid item>
      <FormField.CheckboxGroup
        name={DAYS}
        validate={valdateField}
        align={'center'}
        padding={'0'}
        options={DAYS_LIST}
      />
    </Grid>
  </Grid>
);

export const DaysTextField = () => (
  <FormField.TextField
    name={DAYS}
    validate={valdateField}
    padding={'0'}
    required={true}
    label={'Month days'}
    helper={'Example: 1, 3-5'}
  />
);
